.progress {
  width: 100%;
  height: 6px;
  border-radius: var(--vc-radius-pill);
  background: var(--vc-gray-soft);
  overflow: hidden;

  &.progressThin {
    height: 4px;
  }

  .progressFill {
    height: 100%;
    border-radius: inherit;
    background: var(--bar-color, var(--vc-brand));
    transition: width 300ms var(--vc-ease);
  }
}

/* Stage segments (card stage progress) */
.segments {
  display: flex;
  gap: 4px;
  width: 100%;

  .segment {
    flex: 1;
    height: 4px;
    border-radius: var(--vc-radius-pill);
    background: var(--vc-gray-soft);

    &.segmentDone {
      background: var(--seg-color, var(--vc-purple));
    }
  }
}
